import { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

class Main extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path={`${process.env.PUBLIC_URL}/`}>
            <Step1 />
          </Route>
          <Route exact path={`${process.env.PUBLIC_URL}/step2`}>
            <Step2 />
          </Route>
          <Route exact path={`${process.env.PUBLIC_URL}/step3`}>
            <Step3 />
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default Main;
